import * as React from 'react';

import { useCustomerMeetsRestrictions } from '../../utils/productFeatureContext';

import {
  TockClassicProductLevel,
  TockEventsProductLevel,
  TockProductType,
  TockSubscriptionAddon,
} from '../../types/productFeatures';

type RenderPropFunction = ({ pass }: { pass: boolean }) => React.ReactNode;

export interface Props {
  minEventsLevel?: TockEventsProductLevel;
  maxEventsLevel?: TockEventsProductLevel;

  minClassicLevel?: TockClassicProductLevel;
  maxClassicLevel?: TockClassicProductLevel;

  onlyForProductType?: TockProductType;

  onlyForSubscriptionAddon?: TockSubscriptionAddon;

  children?: React.ReactNode | RenderPropFunction;
}

const ProductFeatureRestriction: React.FunctionComponent<Props> = ({
  minEventsLevel = TockEventsProductLevel.ESSENTIAL,
  maxEventsLevel = TockEventsProductLevel.PREMIUM,
  minClassicLevel = TockClassicProductLevel.INTRO,
  maxClassicLevel = TockClassicProductLevel.PRO,
  onlyForProductType,
  onlyForSubscriptionAddon,
  children,
}: Props) => {
  const meetsRestrictions = useCustomerMeetsRestrictions({
    minEventsLevel,
    maxEventsLevel,
    minClassicLevel,
    maxClassicLevel,
    onlyForProductType,
    onlyForSubscriptionAddon,
  });

  if (meetsRestrictions === null) {
    return null;
  }

  if (typeof children === 'function') {
    const renderFunc = children as RenderPropFunction;
    return (
      <>
        {renderFunc({
          pass: meetsRestrictions,
        })}
      </>
    );
  }

  if (meetsRestrictions) {
    return <>{children}</>;
  }
  return null;
};

export default ProductFeatureRestriction;
